"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogThumbnailLink = exports.BlogThumbnails = exports.ImageContainer = exports.Container = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: black;\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  > * {\n    margin-bottom: 10px;\n  }\n"], ["\n  color: black;\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  > * {\n    margin-bottom: 10px;\n  }\n"])));
exports.ImageContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: grey;\n  height: 225px;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n"], ["\n  background: grey;\n  height: 225px;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n"])));
exports.BlogThumbnails = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-self: flex-start;\n  > * {\n    margin-right: 20px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-self: flex-start;\n  > * {\n    margin-right: 20px;\n  }\n"])));
exports.BlogThumbnailLink = styled_components_1.default.a(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: flex-bottom;\n  margin-top: auto;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: flex-bottom;\n  margin-top: auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;